import { setUseLocalCurrency } from 'api/User/actions'
import { connect } from 'react-redux'
import { setLanguage } from 'redux-i18n'
import { toggleReportBugDialog } from 'ReportBugDialog/actions'
import type { State } from 'store/types'

import { toggleMenu } from './actions'
import SideMenu from './SideMenu'

interface OwnProps {
  logout: () => void
}

const mapStateToProps = ({ i18nState, ui, user }: State, ownProps: OwnProps) => ({
  behalfOfUserName: user.settings.behalfOfUserName,
  isMenuOpened: ui.sideMenu.isMenuOpened,
  lang: i18nState.lang,
  useLocalCurrency: user.settings.useLocalCurrency,
  ...ownProps,
})

export default connect(mapStateToProps, {
  toggleMenu,
  toggleReportBugDialog,
  setLanguage,
  setUseLocalCurrency,
})(SideMenu)
